import fr from './fr.json';

const translate = (key) => {
	return fr[key] ? fr[key] : `*${key}*`;
};

export default translate;
